
import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Check, PhoneCall } from 'lucide-react';
import { ServiceData } from '@/types/serviceTypes';

interface ServiceHeaderProps {
  service: ServiceData;
}

const ServiceHeader = ({ service }: ServiceHeaderProps) => {
  const navigate = useNavigate();
  
  return (
    <section className="pt-32 pb-20 bg-gradient-to-b from-pkgreen-100/80 to-white relative">
      <div className="container mx-auto px-4">
        <div className="flex items-center mb-8">
          <Button 
            variant="ghost" 
            className="text-pkgreen-600 hover:text-pkgreen-700 hover:bg-pkgreen-50 -ml-4"
            onClick={() => navigate('/services')}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Services
          </Button>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-6 text-pkstone-900">
              {service.title}
            </h1>
            <p className="text-xl text-pkstone-700 mb-8">
              {service.description}
            </p>
            <div className="space-y-4 mb-8">
              {service.features.slice(0, 3).map((feature, index) => (
                <div key={index} className="flex items-start">
                  <Check className="h-5 w-5 text-pkgreen-500 mr-3 flex-shrink-0 mt-1" />
                  <span className="text-pkstone-700">{feature}</span>
                </div>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-pkgreen-600 hover:bg-pkgreen-700">
                <Link to="/contact">
                  Request a Consultation
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-pkgreen-600 text-pkgreen-600 hover:bg-pkgreen-50">
                <a href="tel:+12034453594">
                  <PhoneCall className="mr-2 h-4 w-4" />
                  (203) 445-3594
                </a>
              </Button>
            </div>
          </div>
          <div className="rounded-xl overflow-hidden shadow-lg">
            <img 
              src={service.image} 
              alt={service.title} 
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.src = "https://images.unsplash.com/photo-1485683761c6c5981b2b970602604d51?q=80&w=2069&auto=format&fit=crop";
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHeader;
